import { render, staticRenderFns } from "./NewsGrowth.vue?vue&type=template&id=fa96f4c0&scoped=true&"
import script from "./NewsGrowth.vue?vue&type=script&lang=js&"
export * from "./NewsGrowth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa96f4c0",
  null
  
)

export default component.exports